import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

import useExcelData from 'hooks/useExcelData';
import ExcelView from 'components/spreadsheet/ExcelView';

const GRNLinesEditModal = ({ show, onHide, selectedItems, onSave }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { data, setData, handleCellsChanged } = useExcelData([]);

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      const formattedData = selectedItems.map(item => ({
        id: item.id,
        product_sku: item.product_sku || '',
        product_name: item.product_name || '',
        vendor_sku: item.vendor_sku || '',
        vendor_name: item.vendor_name || '',
        shelf_code: item.shelf_code || '',
        shelf_name: item.shelf_name || '',
        inventory_type: item.inventory_type || '',
        quantity: item.quantity || '',
        total_amount: item.total_amount || '',
        approved_by: item.approved_by || '',
      }));

      setData(formattedData);
    }
  }, [selectedItems, setData]);

  const columns = [
    { key: 'product_sku', header: 'Product SKU', disabled: true, width: 200 },
    { key: 'product_name', header: 'Product Name', disabled: true, width: 300 },
    { key: 'vendor_sku', header: 'Vendor SKU', disabled: true },
    { key: 'vendor_name', header: 'Vendor Name', disabled: true, width: 200 },
    { key: 'shelf_code', header: 'Shelf Code' },
    { key: 'inventory_type', header: 'Category', disabled: true, width: 200 },
    {
      key: 'quantity',
      header: 'Quantity',
      disabled: true,
      type: 'number',
      width: 150,
    },
    {
      key: 'total_amount',
      header: 'Total Amount',
      disabled: true,
      type: 'number',
      width: 150,
    },
    { key: 'approved_by', header: 'Approved By', disabled: true, width: 250 },
  ];

  const handleSave = async () => {
    setIsSaving(true);

    try {
      const updatedItems = data.map(row => ({
        id: row.id,
        shelf_code: row.shelf_code,
      }));

      await onSave(updatedItems);
      onHide();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen={true}>
      <Modal.Header closeButton>
        <Modal.Title>Edit GRN Lines</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data.length === 0 ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <ExcelView
            data={data}
            columns={columns}
            onCellsChanged={handleCellsChanged}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isSaving || data.length === 0}
        >
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GRNLinesEditModal;
